import React from 'react'
import moment from 'moment'

const SlipData = ({ data }) => {
  return (
    <div>
      <hr />
      <h4>
        {data?.description}
        {data.slipTrx?.solvedBy?.userName && `โดยแอดมิน ${data.slipTrx?.solvedBy?.userName}`}
      </h4>
      <h4>
        {data.slipTrx?.solvedBy?.createdAt &&
          `วันที่ เวลา ที่กดทำรายการคืนเงิน :  ${moment(data.slipTrx?.solvedBy?.createdAt).format(
            'DD/MM/YYYY HH:mm:ss',
          )}`}
      </h4>

      {data?.orderDetail && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '16px',
            color: '#333',
          }}
        >
          <div>
            {data.slipTrx?.imageUrl ? (
              <img alt="" src={data.slipTrx?.imageUrl} width="100%" />
            ) : (
              <h4>ไม่พบรูปภาพสลิป</h4>
            )}
          </div>
          <div>
            <section>
              <h4>รายละเอียดคำสั่งซื้อ</h4>
              <div>
                <span>รหัสคำสั่งซื้อ</span>
                <span className="float-right">{data.orderDetail?.refNo}</span>
              </div>
              <div>
                <span>สถานะคำสั่งซื้อ</span>
                <span className="float-right">{data.orderDetail?.status}</span>
              </div>
              <div>
                <span>ราคารวม</span>
                <span className="float-right">
                  {Number(data.orderDetail?.totalPrice).toLocaleString('th-TH', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}{' '}
                  บาท
                </span>
              </div>
            </section>
            <hr />
            <h4>รายละเอียดลูกค้า</h4>
            <div>
              <span>ชื่อ-นามสกุล</span>
              <span className="float-right">
                {data.orderDetail?.userInfo.firstName} {data.orderDetail?.userInfo.lastName}
              </span>
            </div>
            <div>
              <span>รหัสลูกค้า</span>
              <span className="float-right">{data.orderDetail?.userInfo.userNo}</span>
            </div>
            <div>
              <span>เบอร์โทรศัพท์</span>
              <span className="float-right">{data.orderDetail?.userInfo.phone}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default SlipData
